import { render, staticRenderFns } from "./IncomingVehicle.vue?vue&type=template&id=503bf4e8&scoped=true"
import script from "./IncomingVehicle.vue?vue&type=script&lang=js"
export * from "./IncomingVehicle.vue?vue&type=script&lang=js"
import style0 from "./IncomingVehicle.vue?vue&type=style&index=0&id=503bf4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503bf4e8",
  null
  
)

export default component.exports